<div [formGroup]="form">
  <div class="row col-12 mt-2" *ngIf="mostrarMensajeMail">
    <ca-card secondary>
      <div ca-card-title>
        {{ 'COMUN.DATOS_CONTACTO.MENSAJE_EMAIL_CABECERA' | translate }}
      </div>
      <div ca-card-content>
        {{ 'COMUN.DATOS_CONTACTO.MENSAJE_EMAIL' | translate }}
      </div>
    </ca-card>
  </div>

  <!-- EMAIL -->
  <div class="row mt-2">
    <div class="col-4">
      <ca-form-field>
        <ca-label>
          {{ 'COMUN.DATOS_CONTACTO.EMAIL' | translate }}
        </ca-label>
        <input 
          caInput 
          placeholder="{{ 'COMUN.DATOS_CONTACTO.EMAIL' | translate }}"
          type="text" 
          formControlName="email" />
      </ca-form-field>
      <ca-error *ngIf="form.controls['email'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
    </div>
  </div>

  <!-- TELÉFONO MÓVIL -->
  <div class="row mt-2">
    <div class="col-4">
      <ca-form-field>
        <ca-label>
          {{ 'COMUN.DATOS_CONTACTO.TLF_MOVIL' | translate }}
        </ca-label>
        <input 
          caInput 
          type="text" 
          formControlName="movil" 
          placeholder="{{ 'COMUN.DATOS_CONTACTO.TLF_MOVIL' | translate }}"/>
      </ca-form-field>
    </div>
  </div>

  <!-- TELÉFONO FIJO -->
  <div class="row mt-2">
    <div class="col-4">
      <ca-form-field>
        <ca-label>
          {{ 'COMUN.DATOS_CONTACTO.TLF_FIJO' | translate }}
        </ca-label>
        <input 
          caInput 
          type="text" 
          formControlName="fijo" 
          placeholder="{{ 'COMUN.DATOS_CONTACTO.TLF_FIJO' | translate }}"/>
      </ca-form-field>
    </div>
  </div>
</div>
